
// Mintable Artworks and Meme
export const memeList: {
  nick: string
  nftType: string
  urlName: string
  infoImg: string
  stake?: boolean
  stakeType?: [string]
  mint?: boolean
}[] = [
  {
    urlName: 'bsc',
    nick: 'BSC Artists',
    nftType: '111,3',
    infoImg: 'bsc',
    mint: true
  },
  {
    urlName: 'love',
    nick: 'Love Meme',
    nftType: '105',
    infoImg: 'love',
    mint: true
  },
  {
    urlName: 'Safepal',
    nick: 'Safepal Meme',
    nftType: '101',
    infoImg: 'safepal',
    mint: true
  },
  {
    urlName: 'Musk&Doge',
    nick: 'Musk&Doge',
    nftType: '4',
    infoImg: 'musk',
    mint: true
  },
  {
    urlName: '1inch&BAKE',
    nick: '1inch&BAKE',
    nftType: '8',
    infoImg: '1inch',
    mint: true
  },
  {
    urlName: 'BAKE&Banana',
    nick: 'BAKE&Banana',
    nftType: '5',
    infoImg: 'banana',
    mint: true
  }
]

// Partner Shops 
export const partnerList: {
  nick: string
  nftType: string
  urlName: string
  infoImg: string
  stake?: boolean
  stakeType?: [string]
}[] = [
  {
    urlName: 'Blin',
    nick: 'Blin',
    nftType: '119',
    infoImg: 'blin',
  },
  {
    urlName: 'TOKAU',
    nick: 'TOKAU',
    nftType: '112',
    infoImg: 'TOKAU',
  },
  {
    urlName: 'RACA',
    nick: 'RACA',
    nftType: '107,113,117,118',
    stake: true,
    stakeType: ['117'],
    infoImg: 'RACA',
  },
  {
    urlName: 'KAKA',
    nick: 'KAKA',
    nftType: '116,122,123',
    infoImg: 'KAKA',
  },
  {
    urlName: 'Seascape',
    nick: 'Seascape',
    nftType: '6',
    infoImg: 'seascape',
  },
  {
    urlName: 'YooShi',
    nick: 'YooShi',
    nftType: '109',
    infoImg: 'yooShi',
  },
  {
    urlName: 'Binance',
    nick: 'Binance',
    nftType: '2',
    infoImg: 'Binance',
  },
  {
    urlName: 'Tokocrypto',
    nick: 'Tokocrypto',
    nftType: '7',
    infoImg: 'tokocrypto',
  },
  {
    urlName: 'Bondly',
    nick: 'Bondly',
    nftType: '110',
    infoImg: 'bondly',
  }]

// Collectibles and Game Assets 
export const gameList: {
  nick: string
  nftType: string
  urlName: string
  infoImg: string
  stake?: boolean
  stakeType?: [string]
  mint?: boolean
}[] = [
  // {
  //   urlName: 'Kryptomon',
  //   nick: 'Kryptomon',
  //   nftType: '124',
  //   infoImg: 'Kryptomon',
  // },
  {
    urlName: 'Binamon',
    nick: 'Binamon',
    nftType: '121',
    infoImg: 'binamon',
  },
  {
    urlName: 'toy',
    nick: 'Alchemy Toys',
    nftType: '115,120',
    infoImg: 'toy',
  },
  {
    urlName: 'doggies',
    nick: 'Crypto Doggies',
    nftType: '104',
    stake: true,
    stakeType: ['104'],
    infoImg: 'doggy',
  },
  {
    urlName: 'bark',
    nick: 'Barking Sounds',
    nftType: '108',
    stake: true,
    stakeType: ['108'],
    infoImg: 'bark',
  },
  {
    urlName: 'equipment',
    nick: 'Doggy Equipment',
    nftType: '114',
    stake: true,
    stakeType: ['114'],
    infoImg: 'equipments',
  },
  {
    urlName: 'poker',
    nick: 'Poker',
    nftType: '106',
    stake: true,
    stakeType: ['106'],
    infoImg: 'poker',
  },
  {
    urlName: 'car',
    nick: 'Rare Car',
    nftType: '103',
    stake: true,
    stakeType: ['103'],
    infoImg: 'car',
  },
  {
    urlName: 'combo',
    nick: 'Bakery Combos',
    nftType: 'combo',
    stake: true,
    stakeType: ['combo'],
    infoImg: 'combo',
  },
  {
    urlName: 'soccer',
    nick: 'Soccer Ball',
    nftType: '100',
    stake: true,
    stakeType: ['100'],
    infoImg: 'soccer',
  },
  {
    urlName: 'pet',
    nick: 'Battle Pets',
    nftType: 'pet',
    infoImg: 'pet',
  },
  {
    urlName: 'weapon',
    nick: 'Weapons',
    nftType: 'weapon',
    infoImg: 'weapon',
  },
  {
    urlName: 'petEgg',
    nick: 'Pet Eggs',
    nftType: 'petEgg',
    infoImg: 'petEgg',
  }
]

export const CollectionArr: {
  nick: string
  nftType: string
  urlName: string
  infoImg: string
  stake?: boolean
  stakeType?: [string],
  mint?: boolean
}[] = [...memeList, ...partnerList, ...gameList]